import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./admindashboard.css";
import Cookies from "js-cookie";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Adminsidebar from "../components/Adminsidebar";
import Adminheader from "../components/Adminheader";
import Uppercase from "../components/Uppercase";
import ReactApexChart from "react-apexcharts";
import { useYearContext } from "../components/YearContext";

const Admindashboard = () => {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const navigate = useNavigate();
  const [selectedMonth, setSelectedMonth] = useState("Jan");

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  //clients
  const [clientsData, setclientsData] = useState([]);
  const fetchClientData = async () => {
    try {
      const response = await axios.get("https://api.easytaxexperts.com/get/clientdata");
      if (response.data.success) {
        setclientsData(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchClientData();
  }, []);

  const filterClientDocuments = clientsData.filter((doc) => {
    const documentDate = doc.registered_at
      ? doc.registered_at.substring(0, 10)
      : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();

    // const startDate = `${parseInt(nextYear) - 1}-09-01`;
    // const endDate = `${nextYear}-08-31`;

    const startDate = `${parseInt(nextYear) - 1}-11-30`;
const endDate = `${nextYear}-11-29`;

    return documentDate >= startDate && documentDate <= endDate;
  });

  //invoice(related revenue)
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    fetchinvoices();
  }, []);

  const fetchinvoices = async () => {
    try {
      const response = await axios.get("https://api.easytaxexperts.com/taxrevenue");

      if (response.data.success) {
        setInvoices(response.data.result);
        console.log(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const filterInvoiceDocuments = invoices.filter((each) => {
    const documentDate = each.InvoiceDate ? each.InvoiceDate : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    // const startDate = `${parseInt(nextYear) - 1}-09-01`;
    // const endDate = `${nextYear}-08-31`;

    const startDate = `${parseInt(nextYear) - 1}-11-30`;
const endDate = `${nextYear}-11-29`;

    const isYearMatch = documentDate >= startDate && documentDate <= endDate;

    return isYearMatch;
  });

  const [data, setData] = useState({
    cards: [
      { title: "Total Revenue", value: "$0", color: "#d3d3d3" },
      { title: "Total Clients", value: "$0", color: "#d3d3d3" },
      { title: "Pending Tax Returns", value: "0", color: "#d3d3d3" },
      { title: "Completed", value: "0", color: "#d3d3d3" },
    ],
  });

  //clients

  const clientstatusesToCount = ["Paymentpending", "Complete"];

  useEffect(() => {
    const totalRecords = filterClientDocuments.length;
    const countClientsByStatus = filterClientDocuments.reduce((acc, doc) => {
      const normalizedStatus = doc.status.replace(/\s+/g, "");
      if (clientstatusesToCount.includes(normalizedStatus)) {
        acc[normalizedStatus] = (acc[normalizedStatus] || 0) + 1;
      }
      return acc;
    }, {});

    setData((prevData) => {
      return {
        ...prevData,
        cards: prevData.cards.map((card) => {
          if (card.title === "Total Clients") {
            return { ...card, value: totalRecords };
          }

          if (card.title === "Pending Tax Returns") {
            return {
              ...card,
              value: `${countClientsByStatus.Paymentpending || 0}`,
            };
          }

          if (card.title === "Completed") {
            return { ...card, value: `${countClientsByStatus.Complete || 0}` };
          }
          return card;
        }),
      };
    });
  }, [filterClientDocuments]);

  //invoice(related to revenue)

  const revenuestatusesToCount = ["Paid"];

  useEffect(() => {
    let totalRevenue = 0;

    filterInvoiceDocuments.forEach((doc) => {
      if (revenuestatusesToCount.includes(doc.PaymentStatus)) {
        totalRevenue += parseFloat(doc.totalBill) || 0;
      }
    });

    // Update the data with the total revenue
    setData((prevData) => {
      return {
        ...prevData,
        cards: prevData.cards.map((card) => {
          if (card.title === "Total Revenue") {
            const formattedRevenue = `$${totalRevenue.toFixed(2)}`; 
            return { ...card, value: formattedRevenue };
          }
          return card;
        }),
      };
    });
  }, [filterInvoiceDocuments]);

  const [series, setSeries] = useState({
    barChart: [
      {
        name: "Revenue",
        data: [5000, 7000, 8000, 6000], // Data for Jan to Apr
      },
    ],
    lineChart: [
      {
        name: "Clients",
        data: [2000, 4000, 3500, 3000], // Data for Jan to Apr
      },
    ],
    dailyChart: {
      Jan: [
        {
          name: "Target",
          data: [
            1000, 1200, 1100, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000,
            2100,
          ],
        },
        {
          name: "Achieved",
          data: [500, 600, 550, 700, 650, 700, 750, 800, 850, 900, 950, 1000],
        },
      ],
      Feb: [
        {
          name: "Target",
          data: [
            1100, 1300, 1200, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100,
            2200,
          ],
        },
        {
          name: "Achieved",
          data: [600, 700, 650, 750, 700, 750, 800, 850, 900, 950, 1000, 1050],
        },
      ],
      // Add similar data for Mar and Apr
    },
  });

  const [options, setOptions] = useState({
    barChart: {
      chart: { type: "bar", height: 350 },
      plotOptions: { bar: { borderRadius: 10 } },
      dataLabels: { enabled: false },
      xaxis: { categories: ["Jan", "Feb", "Mar", "Apr"] },
      fill: { colors: ["#4169E1"] },
    },
    lineChart: {
      chart: { type: "line", height: 350 },
      dataLabels: { enabled: false },
      stroke: { curve: "smooth" },
      xaxis: { categories: ["Jan", "Feb", "Mar", "Apr"] },
      colors: ["#4169E1"],
    },
    dailyChart: {
      chart: { type: "bar", height: 350 },
      plotOptions: { bar: { borderRadius: 10 } },
      dataLabels: { enabled: false },
      xaxis: {
        categories: Array.from({ length: 31 }, (_, i) => (i + 1).toString()),
      },
      fill: {
        colors: ["#FF4141", "#0D7C66"], // Update the colors here
      },
      legend: {
        markers: {
          fillColors: ["#FF4141", "#0D7C66"], // Update the colors in the legend
        },
      },
    },
  });

  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role !== "admin") {
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/login");
    } else {
      const decoded = jwtDecode(token);
      setUsername(decoded.email || decoded.phoneNumber);
      setRole(decoded.role);
      if (decoded.role !== "admin") {
        navigate("/login");
      }
    }
  }, [navigate]);

  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      const fetchUserData = async () => {
        try {
          const token = Cookies.get("token");
          const response = await axios.get(" https://api.easytaxexperts.com/admin", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log(response.data);
        } catch (error) {
          console.error("Error:", error);
          if (error.response && error.response.status === 401) {
            // navigate("/");
          }
        }
      };

      fetchUserData();
    }
  }, [navigate]);

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Adminheader openSidebar={openSidebar} />
        <Adminsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container mt-2">
            <div>
              <div className="container">
                <div className="row ">
                  {data.cards.map((card, index) => (
                    <div className="col-lg-3 col-md-6 col-sm-12" key={index}>
                      <div
                        className=" card dashboard-card mb-2"
                        style={{ backgroundColor: card.color }}
                      >
                        <div className="card-text">
                          <h6>{card.title}</h6>
                          <h4>{card.value}</h4>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <ReactApexChart
                    options={options.barChart}
                    series={series.barChart}
                    type="bar"
                    height={350}
                  />
                </div>
                <div className=" col-lg-6 col-md-12 col-sm-12">
                  <ReactApexChart
                    options={options.lineChart}
                    series={series.lineChart}
                    type="line"
                    height={350}
                  />
                </div>
              </div>

              <div className="mt-2">
                <label>Month</label>
                <select
                  className="form-select"
                  value={selectedMonth}
                  onChange={handleMonthChange}
                  label="Month"
                >
                  <option value="Jan">January</option>
                  <option value="Feb">February</option>
                  <option value="Mar">March</option>
                  <option value="Apr">April</option>
                </select>

                <ReactApexChart
                  options={options.dailyChart}
                  series={series.dailyChart[selectedMonth]}
                  type="bar"
                  height={350}
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Admindashboard;
